export class LookUpViewModel {
    lookUpId: number;
    code: string;
    description: string;
}
